module.exports = __webpack_public_path__ + "media/images/top_menu_icon/users_index-285b30d95a16936706df731a2abd6656.png";